import { h } from '@stencil/core';

const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 29 22" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.7876 16.7188L3.94391 9.86818C3.31868 9.24237 2.30702 9.24237 1.68337 9.86818C1.05817 10.4929 1.05817 11.5004 1.68337 12.1251L9.65564 20.114C10.2793 20.7387 11.2918 20.7387 11.9147 20.114L27.9293 4.10962C28.5545 3.48493 28.5561 2.47503 27.9323 1.85152C27.3086 1.21065 26.2969 1.21065 25.6718 1.83416L10.7876 16.7188Z"
        fill="#81F44A"
        stroke="#81F44A"
      />
    </svg>
  );
};

export default Icon;
